import React from 'react';

const DetalleAlarma = ({ alarma, dispositivo, videos }) => {
  return (
    <div className='p-0'>
      {[1,2,4].includes(dispositivo.proveedor.id) && alarma.id && !alarma.videoGenerado? "Video el video aun no se ha generado": ""}
      {[1,2,4].includes(dispositivo.proveedor.id) && alarma.id && alarma.videoGenerado && !alarma.existeVideo? "El video no existe": ""}
      {alarma.id ?
        <ul className="list-group list-group-flush p-0">
          <li className="list-group-item p-2"> <i className="fa fa-truck"></i> Unidad: {dispositivo ? dispositivo.nombre : ""}</li>
          <li className="list-group-item p-2"> <i className="fa fa-user"></i> Operador: {alarma.driverName}</li>
          <li className="list-group-item p-2"> <i className="fa fa-fa fa-bars"></i> Grupo: {dispositivo ? dispositivo.grupo : ""}</li>
          <li className="list-group-item p-2"> <i className="fa fa-calendar"></i> Fecha: {alarma.alarmaFecha}</li>
          <li className="list-group-item p-2"> <i className="fa fa-bell"></i> Alarma: {alarma.tipoString}</li>
          <li className="list-group-item p-2"> <i className="fa fa-map-marker"></i> Coordenadas: {alarma.latitud} , {alarma.longitud}</li>
          <li className="list-group-item p-2"> <i className="fa fa-compass"></i> Dirección: {alarma.direction}</li>
          <li className="list-group-item p-2"> <i className="fa fa-tachometer"></i> Velocidad: {alarma.velocidad} KM/H</li>
        </ul>
      : ""}
    </div>
  );
};

export default DetalleAlarma;
